import { createContext, useContext } from 'react';

import React from 'react';
import { UserInfo } from 'src/core/types';
export interface AuthorizationContextType {
  /**
   * The token for the user. If it's non-null, we assume the user is logged in,
   * otherwise not.
   */
  accessToken: string | null;
  login: (accessToken: string, refreshToken: string) => void;
  logout: () => void;
  setUser: React.Dispatch<React.SetStateAction<UserInfo | null>>;
  user: UserInfo | null;
}

export const AuthorizationContext =
  createContext<AuthorizationContextType | null>(null);

export const useAuthorizationContext = (): AuthorizationContextType => {
  const context = useContext(AuthorizationContext);
  if (context == null) {
    throw new Error(
      'useAuthorizationContext must be used within AuthorizationContext.Provider.',
    );
  }
  return context;
};
